const apiRoutes = {
  GAMEBOX: "/api/accountMissions",
  GAME_BOX_MISSION_COUNT: "/api/getActiveMissionsCount",
  GET_MISSION: '/api_v2/wageringMission/getAccountActiveWageringMissions',
  GET_ACTIVE_JACKPOTS: '/api/getActiveRaffles',
  GET_ACTIVE_JACKPOT_TICKETS: '/api/getActiveRafflesTickets',
  GET_CASINO_TOURNAMENT_INSTANCES: '/casinoTournament/getCasinoTournamentInstances',
  GET_CASINO_TOURNAMENT_NEXT_INSTANCE: '/casinoTournament/getCasinoTournamentNextInstance',
  GET_FREESPINS_WAGERING_GAMES: '/lobby/getFreespinsWageringGames',
  GET_GAME_URL: '/lobby/gameUrl',
  GET_PROGRESSIVE_MISSIONS: '/api/getAccountProgressiveMissions',
  GET_RACES: '/api/getRaces',
  GET_RACES_LEADERBOARD: '/api/getRaceLeaderBoard',
  JOIN_TO_RACE: '/api/joinToRace',
  OPT_TO_MISSION: '/api/optInToMission',
  RAFFLE_RULES: '/api/game-box-content',
  FIRST_DEPOSIT_TO_BONUS: '/api_v2/firstDepositToBonusWallet',
  GET_MINI_GAMES: '/minigamesList',
  SPORT_TEAM_TO_START: '/api/selectSportTeamToStart'
};

export default apiRoutes;
